module.exports = __webpack_public_path__ + "img/society-yi-xing-avatar.848dc3a0.png";